import { types } from '../../../types/types';

export const reducerPesquisaCodigoPromocional = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.PESQUISA_CODIGOPROMOCIONAL:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const reducerCodigoPromocionalSelecionado = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.CODIGOPROMOSELECIONADO:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const reducerCodigoPromocionalNovoAtualiza = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.PRODNOVOATUALIZA:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}